import React, { useState } from "react";
import { Form, Button, Col, Table } from "react-bootstrap";
import { useFormik } from "formik";
import {
  serviceActions,
  useServiceReducer,
} from "../../../reducers/serviceReducer";

import { findEntities } from "../../../services/Results";
import InfoBox from "../../system/InfoBox";

export default function CheckEntityForm(props) {
  const [result, setResult] = useState(null);
  const [serviceState, serviceDispatch] = useServiceReducer();

  async function searchEntities(text) {
    props.onSelectEntity(null);
    serviceDispatch({ type: serviceActions.LOADING });
    setResult(null);
    try {
      const result = await findEntities(text);
      serviceDispatch({ type: serviceActions.SUCCESS });
      setResult(result);
      console.log(result);
    } catch (err) {
      console.log("error", err);
      serviceDispatch({ type: serviceActions.ERROR, payload: err.message });
    }
  }

  function EntityResults() {
    if (result) {
      if (result.Items && result.Items.length) {
        return (
          <Table responsive size="sm">
            <thead>
              <tr>
                <th>Entity</th>
                <th>Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {result.Items.map((entity, index) => {
                return (
                  <tr key={`entity_${index}`}>
                    <td>{entity.entity}</td>
                    <td>{entity.type}</td>
                    <td>
                      <Button
                        variant="info"
                        onClick={() => props.onSelectEntity(entity.entity)}
                      >
                        Choose
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        );
      } else {
        return <InfoBox type="warning" message="No matching entity is found" />;
      }
    } else {
      return null;
    }
  }
  // Pass the useFormik() hook initial form values and a submit function that will
  // be called when the form is submitted
  const formik = useFormik({
    initialValues: {
      entityName: "",
    },
    onSubmit: (values) => {
      searchEntities(values.entityName);
    },
  });
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Form.Row className="align-items-center">
          <Col xs="auto">
            <input
              id="entityName"
              name="entityName"
              type="text"
              className="form-control mb-2"
              placeholder="Enter entity name"
              onChange={formik.handleChange}
              value={formik.values.entityName}
            />
          </Col>
          <Col xs="auto">
            <Button
              variant="outline-primary"
              className="mb-2"
              disabled={
                serviceState.loading || !formik.values.entityName.trim().length
              }
              type="submit"
            >
              Check availability
            </Button>
          </Col>
        </Form.Row>
      </form>
      <EntityResults />
    </>
  );
}
